import { post } from "@/axios";

/**
 * 导入导出中心分页
 * **/
export const oneServiceTaskPage = function (params) {
    return post('/oneService/task/page', params)
}
/**
 * 下载导入导出数据
 * **/
export const oneServiceDownloadExportData = function (params) {
    return post('/oneService/task/downloadExportData', params)
}
/**
 * 下载失败数据
 * **/
export const oneServiceDownloadImportFailData = function (params) {
    return post('/oneService/task/downloadImportFailData', params)
}